import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Type,
  ViewChild
} from '@angular/core';
import {
  BidHistory,
  BidItem,
  BidListService,
  BuyErrors,
  Distance,
  FinanceSource,
  InventoryItemDetail,
  LaunchDarklyService,
  LeadBuyerStateModel,
  Organization,
  OrganizationState,
  PaginationState,
  RemoveFromBidList,
  SetCurrentUser,
  TransportationFeeTier,
  UpdateBidListCollapsedState,
  UserPreferences,
  VDPConfigurationState,
  DateUtilsService,
  BookValueSpreadProviderName,
  BookProviderService,
  RemoveSharedListVehicleFromSelections,
  AddSharedListVehicleToSelections,
  BidInventoryItem,
  UserService,
  AddBidListVehicleToSelections,
  RemoveBidListVehicleFromSelections,
  RemoveVehicleUuidFromSelections,
  AddVehicleUuidToSelections,
  VehicleToggleState,
  AuctionFeeService,
  UserConfiguration
} from 'remarketing-angular-library';
import * as _ from 'lodash';
import { get, isNil } from 'lodash';
import { Observable, of, Subscription } from 'rxjs';
import { catchError, distinctUntilChanged, filter, finalize, map, skipWhile, take, takeUntil, tap } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { OfferModalsComponent } from '../offer-modals/offer-modals.component';
import { OffersService } from '../../../shared/services/offers/offers.service';
import { BuyNowModalComponent } from './../buy-now-modal/buy-now-modal.component';
import { EditDeliveryModalComponent } from './../edit-delivery-modal/edit-delivery-modal.component';
import { EditDealershipModalComponent } from './../edit-dealership-modal/edit-dealership-modal.component';
import { BidModalComponent } from '../bid-modal/bid-modal.component';
import { BidModalRefactorComponent } from '../../refactor/bid-modal-refactor/bid-modal-refactor.component';
import { HttpErrorResponse } from '@angular/common/http';
import {
  ActionSubmittingModalComponent,
  AuctionBadgeComponent,
  BuyerTipsComponent, ConditionIndicatorComponent,
  DatalistItemComponent,
  SharedListWarningComponent, TableModule,
  TooltipComponent,
  TrackButtonDirective,
  TransportationEstimateComponent,
  VehicleDisclosuresIndicatorComponent
} from 'remarketing-ui-components-lib';
import { BannerComponent, BannerConfig, BannerMode } from '../../../shared/components/banner/banner.component';
import { BidHistoryModalComponent } from './../bid-history-modal/bid-history-modal.component';
import { OfferModalItem } from '../../../shared/models/offer-modal-item.model';
import { BidModalItem } from '../../models/bid-modal-item.model';
import { FinanceSourceSelection } from '../../models/finance-source-selection.model';
import { FinanceSourcesModalComponent } from '../finance-sources-modal/finance-sources-modal.component';
import { OfferHistory } from '../../../shared/models/offer-history.model';
import { VehiclesService } from '../../services/vehicle-detail/vehicles.service';
import { VehicleDetailRoutingService } from '../../services/vehicle-detail-routing/vehicle-detail-routing.service';
import { BidResponse } from '../../models/bid-response.model';
import { Router, RouterModule } from '@angular/router';
import {
  EditCommentComponent,
  SaveCommentModalComponent,
  TransportationFeeModalComponent
} from '@ally/remarketing/shared/ui';
import { AuctionItemStatusService } from 'src/vehicles/services/auction-item-status/auction-item-status.service';
import { AutoBidWithdrawModalComponent } from '../auto-bid-withdraw-modal/auto-bid-withdraw-modal.component';
import { AutoBidWithdrawModalItemModel } from '../../models/auto-bid-withdraw-modal-item.model';
import { BidListStateService } from '../../services/bid-list-state-service/bid-list-state.service';
import { FeeToolTipService } from '../../../shared/services/feetooltip/feetooltip.service';
import {
  DRIP_TOOLTIP_TRIGGERS,
  DripFeeSource,
  DripPricingService,
  DripTotalLabelContext
} from '../../../shared/services/drip-pricing/public-api';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { ServiceFeeScheduleModalComponent } from '../../../shared/ui/modals/service-fee-schedule-modal/service-fee-schedule-modal.component';
import { SharedListCommonActionModalComponent } from '../shared-list-common-action-modal/shared-list-common-action-modal.component';
import { AnalyticsService, WebsocketService, WebsocketUrl, SaComponent, OfferModalEvent, CurrencyFormatService, BadgeStatusPipe, NameTruncatePipe } from 'smartauction-frontend-micro-library';
import { SellerOfferStatus } from 'remarketing-angular-library/enums/enums';
import { SharedListToggleService } from '../../services/shared-list-toggle/shared-list-toggle.service';
import { SharedListStateService } from '../../services/shared-list-state-service/shared-list-state.service';
import { FeeTooltipFormatterService } from 'src/app/shared/fee-tooltip-formatter/fee-tooltip-formatter.service';
import { BidListToggleService } from '../../services/bid-list-toggle/bid-list-toggle.service';
import { MissedOfferAlternativeRecommendationsComponent } from '../../../shared/components/missed-offer-alternative-recommendations/missed-offer-alternative-recommendations.component';
import { CommonModule, DecimalPipe, NgIf, NgSwitchCase, TitleCasePipe } from '@angular/common';
import { ParseStringPipe } from 'src/shared/ui/pipes/parse-string/parse-string.pipe';
import { OfferButtonTextPipe } from 'src/vehicles/pipes/offer-button-text/offer-button-text.pipe';
import { AutoBidButtonTextPipe } from 'src/vehicles/pipes/auto-bid-status/auto-bid-button-text.pipe';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { FinanceSourcesPopoverComponent } from './finance-sources-popover/finance-sources-popover.component';
import { ViewAllBySellerLinkComponent } from 'src/shared/components/view-all-by-seller-link/view-all-by-seller-link.component';
import { SwIconContainerHookComponent } from 'src/shared/components/stockwave/sw-icon-container-hook/sw-icon-container-hook.component';
import { ModalLauncherService } from '../common-list/modal-launcher/modal-launcher.service';

@Component({
    selector: 'bidlist-inventory-item',
    templateUrl: './bidlist-inventory-item.component.html',
    styleUrls: ['./bidlist-inventory-item.component.scss'],
    imports: [
        TranslocoDirective,
        CommonModule,
        NgIf,
        BannerComponent,
        NgSwitchCase,
        TooltipComponent,
        DatalistItemComponent,
        TransportationEstimateComponent,
        AuctionBadgeComponent,
        BadgeStatusPipe,
        DecimalPipe,
        ParseStringPipe,
        NameTruncatePipe,
        TitleCasePipe,
        OfferButtonTextPipe,
        AutoBidButtonTextPipe,
        VehicleDisclosuresIndicatorComponent,
        TabsModule,
        BuyerTipsComponent,
        FinanceSourcesPopoverComponent,
        ViewAllBySellerLinkComponent,
        SwIconContainerHookComponent,
        RouterModule,
        TrackButtonDirective,
        EditCommentComponent,
        SharedListWarningComponent,
        ConditionIndicatorComponent,
        TableModule
    ]
})
export class BidlistInventoryItemComponent extends SaComponent implements OnInit, AfterViewChecked, OnDestroy {
  @Input() set bidItem(item: BidInventoryItem) {
    this._bidItem = item;
    this.offerModalItem = OfferModalItem.fromBidItem((item as unknown) as BidItem);
    this.bidModalItem = BidModalItem.fromBidInventoryItem(item);
  }

  get bidItem() {
    return this._bidItem;
  }
  @Input() variant: 'recommendation' | 'result';
  @Input() isSelected = false;
  @Input() urlBase: string;
  @Input() urlBaseExternal: boolean;
  @Input() userPreferences: UserPreferences;
  @Input() financeSources: FinanceSource[] = [];
  @Input() tenantName: string;
  @Input() currentPage: number;
  @Input() index: number;
  @Input() view?: string;
  @Input() bidlistMultiRemoveLimit?: number;
  @Input() dealershipCollection: Organization[] = [];
  @Input() dealershipFinanceMap = {};
  @Input() buyerTipEnabled: boolean;
  @Input() isSharedListVehicleSelected = false;
  @Input() isBidListVehicleSelected = false;
  @Input() isVehicleSelected = false;
  @Input() isSelectAllChecked = false;
  @Input() paginatedSharedList$: Observable<{ items: BidItem[]; pagination: PaginationState }>;
  @Input() paginatedBidList$: Observable<{ items: BidItem[]; pagination: PaginationState }>;
  @Input() bidListMultiSelectEnabled = false;
  @Input() hide = false;
  @Input() isListView;
  @Input() bidlistInventoryItemTranslations;
  @Input() platformSpareKeyFee: number | undefined;

  @Output() hidden = new EventEmitter<void>();
  @Output() selected = new EventEmitter<void>();
  @Output() bidlisted = new EventEmitter<void>();
  @Output() removeItem = new EventEmitter<void>();
  @Output() readdItem = new EventEmitter<void>();
  @Output() onItemUpdate = new EventEmitter<void>();
  @Output() bidItemUpdated = new EventEmitter<BidInventoryItem>();
  @Output() onReviewSelectAllNeeded = new EventEmitter<void>();

  @ViewChild('kabobPopOver') popover;
  @ViewChild('offerActionButton') offerActionButton: ElementRef;

  private autoBidWithdrawModalRef?: ComponentRef<AutoBidWithdrawModalComponent>;
  private transportationFeeModalRef?: ComponentRef<TransportationFeeModalComponent>;
  private serviceFeeScheduleModalRef?: ComponentRef<ServiceFeeScheduleModalComponent>;
  private offerModalsRef?: ComponentRef<OfferModalsComponent>;
  private buyNowModalsRef?: ComponentRef<BuyNowModalComponent>;
  private editDeliveryModalsRef?: ComponentRef<EditDeliveryModalComponent>;
  private editDealershipModalsRef?: ComponentRef<EditDealershipModalComponent>;
  private bidModalRef?: ComponentRef<BidModalComponent | BidModalRefactorComponent>;
  private actionSubmittingModalRef?: ComponentRef<ActionSubmittingModalComponent>;
  private financeSourcesModalRef?: ComponentRef<FinanceSourcesModalComponent>;
  private bidHistoryModalRef?: ComponentRef<BidHistoryModalComponent>;
  private sharedListCommonActionModalRef?: ComponentRef<SharedListCommonActionModalComponent>;
  private moaRecommendationsRef?: ComponentRef<MissedOfferAlternativeRecommendationsComponent>;

  formattedQuote;
  formattedExpiryDate: string;
  commentsModalInstance: SaveCommentModalComponent;
  private _bidItem: BidInventoryItem;
  offerModalItem: OfferModalItem;
  bidModalItem: BidModalItem;
  transportationFeeTiers: TransportationFeeTier[];
  _subscription$: Subscription;
  bidListCommentName = 'Buyer Bid List Comment';
  transTransaltions: any;
  isSharedList: boolean;
  showButtons: boolean;
  activeAuctionButtons: boolean;
  bidListButtons: boolean;
  showToolTip = false;
  selectPDFtext: string;
  errorCode: any;
  errorMsg: any;
  actionTextRemovingBid: string;
  bannerErrorCode: any;
  bannerErrorMsg: any;
  localTimeZoneNameExtended: string;
  vehicleRemovedSuccessMsg: boolean;
  distance: Distance;
  // need to update the organization interface, however, the schema seems unstable, using any type for now
  // organization: Organization;
  organization: any;
  isMobile: boolean;
  isTablet: boolean;
  showBanner = false;
  imgUrlLarge: string;
  currentTime: number;
  _startTime: number;
  endTime: number;
  extendedTime: number;
  showStartTime = false;
  showEndTime = false;
  showExtendedTime = false;
  showSellerOfferExpiry = false;
  hasFinanceInlineError = false;
  financeInlineError = BuyErrors.MSG_BUY_002;
  labelSellerOfferExpires: string;
  notAvailable: string;
  viewSimilarBtn: string;
  button: HTMLElement;
  bidHistory: { [key: string]: BidHistory[] };
  hasOfferHistoryError = false;
  private spreadToBook: number;
  waitingForOffers = false;
  errorMessage: string;
  editingComment = false;
  offerHistory: OfferHistory[];
  highBidderToolTip: any;
  indicatorCharacter: string;
  indicatorBody: string;
  indicatorAriaLabel: string;
  toolTipContent: any;
  singleFeeAmount: string;
  scrollPosition = 0;
  collapsedState = true;
  feeListSize: number;
  sharedListResults: BidItem[];
  bidListResults: BidItem[];
  banner: BannerConfig = {
    text: '',
    mode: BannerMode.NONE,
    showIcon: false,
    showUndo: false
  };
  translations = {
    textStockUnit: '',
    textInspectionSeries: '',
    partOf: '',
    sharedList: '',
    customOffer: '',
    currentListType: ''
  }

  allytmln = {
    accept: 'accept',
    counter: 'counter',
    decline: 'decline'
  };

  leadBuyerState: LeadBuyerStateModel;
  formattedSpreadToBookLabels: { bookProviderName: string; bookProviderValue: string; } = {
    bookProviderName: '',
    bookProviderValue: ''
  };

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.detectIfMobile();
  }

  constructor(
    private store: Store,
    private readonly offersService: OffersService,
    private bidListService: BidListService,
    private readonly modalLauncherService: ModalLauncherService,
    private vehicleService: VehiclesService,
    private router: Router,
    private readonly feeToolTipService: FeeToolTipService,
    private _websocketService: WebsocketService,
    private _auctionItemService: AuctionItemStatusService,
    private readonly changeDetector: ChangeDetectorRef,
    readonly bidListStateService: BidListStateService,
    private readonly bookProviderService: BookProviderService,
    private readonly auctionFeeService: AuctionFeeService,
    readonly _analyticsService: AnalyticsService,
    private readonly tooltipService: FeeToolTipService,
    protected readonly dripPricingService: DripPricingService,
    private readonly _launchDarklyService: LaunchDarklyService,
    readonly dateUtilService: DateUtilsService,
    private readonly translocoService: TranslocoService,
    private readonly feeTooltipFormatterService: FeeTooltipFormatterService,
    private readonly sharedListToggleService: SharedListToggleService,
    private readonly bidListToggleService: BidListToggleService,
    private readonly sharedListStateService: SharedListStateService,
    readonly currencyFormatService: CurrencyFormatService,
    private readonly userService: UserService,
    private readonly vehicleDetailRoutingService: VehicleDetailRoutingService
  ) {
    super();
  }

  get showWinningOffer(): boolean {
    return (
      !this.isSharedList &&
      this.showVOCItems &&
      (get(this.bidItem, 'purchaseType') === 'SELLER_OFFER_ACCEPTED' ||
        get(this.bidItem, 'purchaseType') === 'BUYER_OFFER_ACCEPTED') &&
      get(this.bidItem, 'buyerAuctionItemStatus') === 'SOLD' &&
      get(this.bidItem, 'offerStatus') === 'CANCELLED'
    );
  }

  get quoteExist() {
    return this.bidItem && this.bidItem.transportationQuote;
  }

  get classList() {
    return `inventory-item ${
      this.isResult ? 'inventory-item--result' : this.isRecommendation ? 'inventory-item--recommendation' : ''
    }`;
  }

  /**
   * Ensures checkbox shows the correct color for enabled/disabled states
   * since relying on [disabled] is unreliable across different browsers
   */
  get checkboxClassList() {
    if (!this.isSharedList) {
      return 'custom-control custom-checkbox';
    }

    return `custom-control ${this.isPendingBuyerAction() ? '' : 'custom-control-disabled '}custom-checkbox`;
  }

  get stockNumber() {
    return get(this.bidItem, 'itemDetail.stockNumber', this.notAvailable);
  }

  get inspectionSeries() {
    return get(this.bidItem.itemDetail, 'inspectionSeries', 'N/A');
  }

  get itemDetails(): InventoryItemDetail | {} {
    return get(this.bidItem, 'itemDetail', {});
  }

  get title() {
    return `${this.detail('modelYear')} ${this.detail('make')} ${this.detail('model')} ${this.detail('trim')}`;
  }

  get getOdometer() {
    const odometer = get(this.bidItem, 'itemDetail.odometer', '');
    return odometer
      ? `${odometer.toLocaleString()} ${this.bidlistInventoryItemTranslations.distanceUnit}`
      : this.notAvailable;
  }

  /**
   * True when the viewing buyer is the one who won this vehicle.
   *
   * Keyed on `buyerAuctionItemStatus` rather than `buyerPurchaseStatus` because the former
   * is a typed literal union, so a typo fails compilation, whereas the latter is a bare
   * `string` carrying mixed-case values. `showTotalPurchasePriceWithCents` and
   * `showWinningOffer` already key on this same field.
   *
   * Narrower than `isPurchasedVehicle`, which the drip gate uses, and deliberately so — see
   * `getTotalPurchasePrice` for why the two predicates answer different questions.
   */
  private get isWinningBuyer(): boolean {
    return this.bidItem.buyerAuctionItemStatus === 'WON';
  }

  /**
   * The amount the Total Purchase Price row is built from, or nil when the row must not
   * render at all. Single source of truth for both `showTotalPurchasePrice` and
   * `getTotalPurchasePrice` so the value and its visibility cannot disagree. SAT-94704.
   *
   * Exactly two cases open the row on the buyer bid list:
   *   1. This buyer won it                -> `salePrice`, always, with no fallback.
   *   2. The vehicle sold, but not to them -> their own `dealershipLastBidAmount`, else
   *                                           their own `offerAmount`.
   * Any other vehicle status (ACTIVE, EXPIRED, HOLD, REMOVED, RESERVED) renders no row, so
   * a live auction never shows a purchase total.
   *
   * On a shared list (`isSharedList`) the row is driven by `offerAmount` alone — that surface
   * shows the viewing dealer their own offer. It no longer falls back to `salePrice`: doing so
   * leaked the winning amount to a dealer who had not offered, the same defect SAT-94704 fixes
   * on the buyer bid list. A shared-list row with no offer therefore renders nothing.
   *
   * Before SAT-94704 both getters keyed solely off `!isNil(salePrice)`. The websocket
   * assigns `salePrice` to every subscriber of an item, win or lose, so a buyer who bid and
   * lost saw the winner's sale price plus their own `buyFee.total` under a purchase label.
   *
   * Case 2 deliberately NARROWS SAT-86046 to winners only: for a non-winner we now
   * substitute that buyer's own last bid or offer instead of hiding the row, including when
   * the offer was withdrawn (a withdrawn offer retains its `offerAmount`). That is an
   * intentional product decision, not a regression of SAT-86046 — do not "restore" the old
   * hide-the-row behaviour. `isNil` throughout, never truthiness, so a 0 amount still
   * renders; nil `offerAmount` is genuinely reachable (bid-only, buy-now, no participation).
   */
  private get totalPurchasePriceBase(): number | undefined {
    if (this.isSharedList) {
      return !isNil(this.bidItem.offerAmount) ? this.bidItem.offerAmount : undefined;
    }

    if (this.isWinningBuyer) {
      return this.bidItem.salePrice;
    }

    if (this.bidItem.auctionItemStatus !== 'SOLD') {
      return undefined;
    }

    return !isNil(this.bidItem.dealershipLastBidAmount)
      ? this.bidItem.dealershipLastBidAmount
      : this.bidItem.offerAmount;
  }

  /**
   * Total Purchase Price on the card. SAT-94704 decides WHICH amount (see
   * `totalPurchasePriceBase`); this getter only decides which fees ride on top of it.
   *
   * With drip pricing off — and on a shared list, or once the vehicle is SOLD/WON — this stays
   * `price + buyFee.total`, i.e. every fee including transportation and tax. That is today's
   * behaviour and buyers of purchased vehicles must keep seeing it unchanged.
   *
   * With drip pricing on for an unsold buyer-side listing the figure becomes the all-in price:
   * price + required fees only (service + documentation), transportation and tax excluded.
   *
   * An `undefined` all-in price (non-finite input) falls through to the original arithmetic rather
   * than to `''`: blanking a row the buyer sees today would be a regression caused by a pricing flag.
   *
   * The fee tail is gated on `isDripPricingApplicable` (buyer-level `isPurchasedVehicle`) while the
   * amount is gated on `isWinningBuyer` (`WON` only). Those predicates differ ON PURPOSE and must
   * not be unified:
   *   - `isPurchasedVehicle` asks "did this buyer agree to pay every fee and tax?" If so, the all-in
   *     subset would contradict their own paperwork, so drip steps aside. A winner always lands here,
   *     so a winner's `salePrice` always carries the full `buyFee.total`, flag on or off.
   *   - `isWinningBuyer` asks "does this buyer get the sale price?"
   * A losing participant on a sold vehicle therefore shows their OWN bid or offer with the all-in
   * tail when the flag is on. That is correct, not a seam: they hold no paperwork for this vehicle,
   * so there is nothing for the all-in subset to contradict, and the breakdown tooltip replaces the
   * FEES rows `showFeeRows` hides. Master already applied the all-in tail to that same row before
   * SAT-94704 — it just applied it to the winner's `salePrice`, which was the leak.
   */
  get getTotalPurchasePrice() {
    const purchasePrice = this.totalPurchasePriceBase;

    if (isNil(purchasePrice)) {
      return '';
    }

    const allInPrice = this.isDripPricingApplicable
      ? this.dripPricingService.allInPriceOf(purchasePrice, this.dripFeeSource)
      : undefined;

    return allInPrice !== undefined ? allInPrice : purchasePrice + this.bidItem.buyFee.total;
  }

  get sellerOfferTooltip() {
    if (this.bidItem.offerListExpiryDate) {
      this.toolTipContent = this.bidItem.offerListExpiryDate;
      const date = this.localizeDateAndTime(this.toolTipContent);
      return { body: `<strong>${this.labelSellerOfferExpires.toUpperCase()}:</strong> <br> ${date}` };
    } else {
      return { body: '' };
    }
  }

  get titleList() {
    const modelYear = this.bidItem.itemDetail.modelYear || '';
    const make = this.bidItem.itemDetail.make || '';
    const model = this.bidItem.itemDetail.model || '';
    const trim = this.bidItem.itemDetail.trim || '';
    const bodyConfiguration = this.bidItem.itemDetail.bodyConfiguration || '';
    const driveTrainAbbrev = this.bidItem.itemDetail.powerTrain.driveTrainAbbrev || '';
    return `${modelYear} ${make} ${model} ${trim} ${bodyConfiguration} ${driveTrainAbbrev}`;
  }

  get isViewOnlyRole(): boolean {
    return this.userService.isViewOnlyRole();
  }

  get showFinanceSourcesPopover(): boolean {
    return this.isEditable && this.selectedFinanceSource && !this.isViewOnlyRole;
  }

  get showFinanceSourceNotPopover(): boolean {
    return this.isEditable && this.selectedFinanceSource && this.isViewOnlyRole;
  }

  get showInspectionSeries() {
    return this.isSharedList && this.isInspectionSeriesEnabled;
  }

  actionIconEllipsisTooltip() {
    let options;
    if (this.isSharedList) {
      //travis
      options = `<a class="btn btn-link text-primary decision-link"> Accept</a>
			<a class="btn btn-link text-primary decision-link"> Counter</a>
			<a class="btn btn-link text-primary decision-link"> Decline</a>`;
    } else {
      options = `<a class="btn btn-link text-primary decision-link"> Bid</a>
			<a class="btn btn-link text-primary decision-link"> Make Offer</a>
			<a class="btn btn-link text-primary decision-link"> Buy Now</a>`;
    }
    return { body: options };
  }

  get vdpLinkList(): string {
    return this.vehicleDetailRoutingService.getVehicleDetailRoute(
      this.bidItem.auctionItemUuid,
      this.bidItem.inventoryItemUuid
    );
  }

  get vdpLink() {
    return this.vehicleDetailRoutingService.getVehicleDetailRoute(
      this.bidItem.auctionItemUuid,
      this.bidItem.inventoryItemUuid
    );
  }

  goToVdp() {
    this._analyticsService.trackEvent('link', this.bidItem.inventoryItemUuid + ' - VDP');
    this.scrollPosition = window.scrollY;
    this.router.navigate([this.vdpLink], {
      state: {
        paginationPage: this.currentPage,
        scrollPosition: this.scrollPosition
      }
    });
  }

  get isStockNumberEnabled() {
    return this.vehicleService.isStockNumberEnabled;
  }

  get isAutoBidEnabled() {
    return this.vehicleService.isAutoBidEnabled;
  }

  get isRecommendation() {
    return this.variant === 'recommendation';
  }

  get isResult() {
    return this.variant === 'result';
  }

  get selectId() {
    return `select-${this.bidItem.inventoryItemUuid}`;
  }

  get reviewedId() {
    return `reviewed-${this.bidItem.inventoryItemUuid}`;
  }

  get modalId() {
    return `Offer-${this.bidItem.inventoryItemUuid}`;
  }

  get transportationFeeModalId() {
    return `Transportation-Fee-${this.bidItem.inventoryItemUuid}`;
  }

  get buyNowModalId() {
    return `Buy-Now-${this.bidItem.auctionItemUuid}`;
  }

  get bidHistoryModalId() {
    return `Bid-History-${this.bidItem.auctionItemUuid}`;
  }

  get editDeliveryModalId() {
    return `Edit-Delivery-${this.bidItem.inventoryItemUuid}`;
  }

  get editDealershipModalId() {
    return `Edit-Dealership-${this.bidItem.inventoryItemUuid}`;
  }

  get bidModalId() {
    return `Bid-Modal-${this.bidItem.inventoryItemUuid}`;
  }

  get autoBidWithdrawModalId() {
    return `Auto-Bid-Withdraw-Modal-${this.bidItem.inventoryItemUuid}`;
  }

  get actionSubmittingModalId() {
    return `Action-Submitting-${this.bidItem.inventoryItemUuid}`;
  }

  get financeSourceModalId() {
    return `Finance-Source-${this.bidItem.inventoryItemUuid}`;
  }

  get feeScheduleModalId() {
    return `Fee-Schedule-${this.bidItem.inventoryItemUuid}`;
  }

  get hasConditionIndicators() {
    return this.bidItem && (this.bidItem.limitedArbitration || this.bidItem.disclosures.length > 0);
  }

  get hasRedLight() {
    return _.get(this.bidItem, 'limitedArbitration', false);
  }

  get hasYellowLight() {
    return _.get(this.bidItem, 'disclosures.length', false);
  }

  get yellowLightDisclosureList() {
    return get(this.bidItem, 'disclosures', []);
  }

  get isActive() {
    const activeStates = ['ACCEPTING_OFFERS', 'OFFER_DECLINED', 'PENDING_BUYER_ACTION', 'PENDING_SELLER_ACTION', 'WON'];

    return this.bidItem.offerAllowed && activeStates.some(state => this.bidItem.buyerAuctionItemStatus === state);
  }

  get limitedOffer() {
    if (this.isSharedList && this.bidItem.buyerAuctionItemStatus !== 'SOLD' && this.bidItem.buyerAuctionItemStatus !== 'WON') {
      return this.isInServiceVehiclesEnabled ? 'avis-red-seller-offer' : 'red-seller-offer';
    } else {
      return 'black-seller-offer';
    }
  }

  get allyconClockClass() {
    if (this.isSharedList) {
      return this.isInServiceVehiclesEnabled ? 'allycon-clock-avis-red' : 'allycon-clock-red';
    } else {
      return 'clock';
    }
  }

  /**
   * When the buyer represents a specific dealership, finance sources are scoped to that
   * dealership rather than the buyer's full cross-dealership list.
   */
  get scopedFinanceSources(): FinanceSource[] {
    return this.selectedDealership
      ? get(this.dealershipFinanceMap, this.bidItem.buyerOeUuid, [])
      : this.financeSources;
  }

  /**
   * We currently don't have a default finance source configuration, so just return
   * the first available value if there is no match.
   */
  get selectedFinanceSource(): FinanceSource {
    const selectedSource = this.scopedFinanceSources.find(
      s => s.financeSourceUuid === this.bidItem.financeSourceUuid && s.achSelected === this.bidItem.financeSourceAch
    );
    if (selectedSource) {
      return selectedSource;
    }
  }

  get financeSourceName(): string {
    const selectedSource = this.selectedFinanceSource;
    return selectedSource ? selectedSource.financeSourceName : this.notAvailable;
  }

  get selectedDealership(): Organization | undefined {
    return this.isLeadBuyer && this.bidItem
      ? this.dealershipCollection.find(x => x.oeUuid === this.bidItem.buyerOeUuid)
      : undefined;
  }

  get localDealer(): boolean {
    if (this.selectedDealership) {
      return this.selectedDealership.organizationProfile.accountTypes.some(
        item => item.name.toLowerCase() === 'local'
      );
    }
    return !!this.organization?.organizationProfile.accountTypes.length &&
      this.organization.organizationProfile.accountTypes[0].name.toLowerCase() === 'local';
  }

  get spreadToBookTooltip() {
    return (
      this.userPreferences && {
        metaTitle: this.bidlistInventoryItemTranslations.spreadToBookTooltipMetaTitle,
        title: this.bidlistInventoryItemTranslations.spreadToBookTooltipTitle,
        body: `${this.bidlistInventoryItemTranslations.spreadToBookTooltipBody}${this.formattedSpreadToBookLabels.bookProviderName}${this.formattedSpreadToBookLabels.bookProviderValue}`
      }
    );
  }

  get selectedDealershipTooltip() {
    return {
      metaTitle: this.bidlistInventoryItemTranslations.selectedDealershipToolTipMetaTitle,
      body: this.selectedDealership?.oeName
    };
  }

  determineIndicator() {
    if (this.bidItem.firstDay) {
      this.indicatorCharacter = 'F';
      this.indicatorBody = this.bidlistInventoryItemTranslations.indicatorBodyFirst;
      this.indicatorAriaLabel = this.bidlistInventoryItemTranslations.indicatorAriaLabelFirst;
      return true;
    } else if (this.bidItem.lastDay) {
      this.indicatorCharacter = 'L';
      this.indicatorBody = this.bidlistInventoryItemTranslations.indicatorBodyLast;
      this.indicatorAriaLabel = this.bidlistInventoryItemTranslations.indicatorAriaLabelLast;
      return true;
    } else if (this.bidItem.oneDay) {
      this.indicatorCharacter = '1';
      this.indicatorBody = this.bidlistInventoryItemTranslations.indicatorBodyOne;
      this.indicatorAriaLabel = this.bidlistInventoryItemTranslations.indicatorAriaLabelOne;
      return true;
    }
    return false;
  }

  get deliveryOptionTooltip() {
    return {
      metaTitle: this.bidlistInventoryItemTranslations.deliveryOptionTooltipMetaTitle,
      body: this.bidlistInventoryItemTranslations.deliveryOptionTooltipBody
    };
  }

  get startTime(): string | boolean {
    const startTime = this.get('postedDate', false);

    return startTime ? startTime : false;
  }

  get auctionStatusTimeLabel() {
    return this.auctionStarted
      ? this.bidlistInventoryItemTranslations.labelEndTime
      : this.bidlistInventoryItemTranslations.labelStartTime;
  }

  get auctionStarted() {
    return this._startTime ? this._startTime <= this.currentTime : true;
  }

  get isLeadBuyer(): boolean {
    return this.vehicleService.isLeadBuyer;
  }


  detail(key: keyof InventoryItemDetail): string {
    return get(this.itemDetails, key, '');
  }

  get(path: string, otherwise: any = '-'): string {
    return get(this.bidItem, path, otherwise);
  }

  select() {
    this.selected.emit();
  }

  updateFinanceSource(financeSourceSelection: FinanceSourceSelection) {
    const { auctionItemUuid, buyerComment, buyerOeUuid, localDelivery } = this.bidItem;
    this.financeSourcesModalRef = this.modalLauncherService.open(
      FinanceSourcesModalComponent,
      { tenantName: this.tenantName, modalId: this.financeSourceModalId },
      this
    );
    this.financeSourcesModalRef.instance.show();
    this.showBanner = false;
    this.hasFinanceInlineError = false;
    this.bidListService
      .updateBidListItem({
        financeSourceUuid: financeSourceSelection.financeSourceUuid,
        financeSourceAch: financeSourceSelection.financeSourceAch,
        auctionItemUuid,
        buyerComment,
        buyerOeUuid,
        localDelivery
      })
      .pipe(take(1))
      .subscribe(
        bidItemResponse => {
          this.financeSourcesModalRef.instance.setSuccessfulResponse();
          this.bidItem = {
            ...this.bidItem,
            buyFee: bidItemResponse.buyFee,
            financeSourceUuid: bidItemResponse.financeSourceUuid,
            financeSourceAch: bidItemResponse.financeSourceAch
          };
          this.bidItemUpdated.emit(this.bidItem);
        },
        err => {
          const error = get(err, 'error.errors[0]');
          this.errorCode = error.code;
          this.showBanner = true;
          this.vehicleRemovedSuccessMsg = false;
          this.bannerErrorCode = this.errorCode;
          this.banner.showIcon = true;
          this.banner.showUndo = false;
          this.banner.mode = BannerMode.ERROR;
          this.hasFinanceInlineError = true;
          this.financeInlineError = this.errorCode;
          this.getTranslations();
          this.financeSourcesModalRef.instance.setErrorResponse();
        }
      );
  }

  getSpreadToBookValue() {
    if (this.spreadToBook) {
      return this.spreadToBook;
    }
    if (!this.userPreferences) {
      return undefined;
    }

    const defaultBookProvider = this.userPreferences.defaultBookProvider.providerName;
    const defaultProviderValue = this.userPreferences.defaultBookProvider.providerValue;

    let bookProviders = [];

    if (defaultBookProvider === BookValueSpreadProviderName.MMR) {
      bookProviders = this.bidItem.bookValues.filter(bookValue => bookValue.providerName === BookValueSpreadProviderName.MANHEIM);
    }
    else {
      bookProviders = this.bidItem.bookValues.filter(bookValue => bookValue.providerName === defaultBookProvider);
    }
    if (bookProviders.length > 0) {
      return this.getCurrentValue(bookProviders, defaultBookProvider, defaultProviderValue);
    }
    return undefined;
  }

  getCurrentValue(bookProviders, defaultBookProvider, defaultProviderValue) {
    const filteredProvider = bookProviders[0];
    let providerValue =
      defaultBookProvider.toLocaleLowerCase() === BookValueSpreadProviderName.NADA.toLocaleLowerCase() ||
        defaultBookProvider.toLocaleLowerCase() === BookValueSpreadProviderName.BLACK_BOOK.toLocaleLowerCase() ||
        defaultBookProvider.toLocaleLowerCase() === BookValueSpreadProviderName.MMR.toLocaleLowerCase()
        ? `${defaultProviderValue}`.toLocaleLowerCase()
        : null;

    //using regex for case-insensitive replacement of 'Adjusted ' from provider value for manheim
    if (providerValue && defaultBookProvider.toLocaleLowerCase() === BookValueSpreadProviderName.MMR.toLocaleLowerCase()) {
      providerValue = providerValue.replace(/^adjusted\s+/i, '');
    }

    const filteredBookValues = filteredProvider.values.filter(
      value => value.providerValue.toLocaleLowerCase() === providerValue
    );

    if (filteredBookValues.length > 0) {
      this.spreadToBook = filteredBookValues[0].spreadToBook;
      return this.spreadToBook;
    }
  }

  changeDeliveryOption(e) {
    const payload = {
      auctionItemUuid: this.bidItem.auctionItemUuid,
      buyerComment: undefined,
      buyerOeUuid: this.bidItem.buyerOeUuid,
      financeSourceAch: this.bidItem.financeSourceAch,
      financeSourceUuid: this.bidItem.financeSourceUuid,
      localDelivery: e
    };

    this.bidListService
      .updateBidListItem(payload)
      .pipe(take(1))
      .subscribe(
        bidItemResponse => {
          this.editDeliveryModalsRef.instance.setSuccessfulResponse();
          this.bidItem = {
            ...this.bidItem,
            localDelivery: bidItemResponse.localDelivery
          };
          this.setAuctionItemFee(this.bidItem.buyerOeUuid);
        },
        err => {
          this.errorCode = err.error.errors[0].code;
          this.getTranslations();
          this.editDeliveryModalsRef.instance.setErrorResponse(this.errorMsg);
        }
      );
  }

  changeSelectedDealership(e) {
    const payload = {
      auctionItemUuid: this.bidItem.auctionItemUuid,
      buyerComment: undefined,
      buyerOeUuid: e.oeUuid,
      financeSourceAch: undefined,
      financeSourceUuid: undefined,
      localDelivery: undefined
    };

    this.bidListService
      .updateBidListItem(payload)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        bidItemResponse => {
          this.editDealershipModalsRef.instance.setSuccessfulResponse();
          this.bidItem = {
            ...this.bidItem,
            buyerOeUuid: bidItemResponse.buyerOeUuid,
            financeSourceAch: bidItemResponse.financeSourceAch,
            financeSourceUuid: bidItemResponse.financeSourceUuid,
            localDelivery: bidItemResponse.localDelivery,
            highestBidderName: bidItemResponse.highestBidderName,
            highestBidder: bidItemResponse.highestBidder,
            vehicleDistance: bidItemResponse.vehicleDistance,
            transportationQuote: bidItemResponse.transportationQuote
          };
          this.setAuctionItemFee(bidItemResponse.buyerOeUuid);
        },
        err => {
          this.errorCode = err.error.errors[0].code;
          this.getTranslations();
          this.editDealershipModalsRef.instance.setErrorResponse(this.errorMsg);
        }
      );
  }

  getTranslatedLocalDeliveryString(hasLocalDelivery: boolean) {
    let returnValue = this.bidlistInventoryItemTranslations.deliveryStatusNotAvailable;
    if (this.localDealer && this.showDelivery) {
      if (hasLocalDelivery === true) {
        returnValue = this.bidlistInventoryItemTranslations.deliveryStatusIncluded;
      } else if (hasLocalDelivery === false) {
        returnValue = this.bidlistInventoryItemTranslations.deliveryStatusNotIncluded;
      }
    }
    return returnValue;
  }

  initializeBookProviderValueLabels() {
    this.formattedSpreadToBookLabels = this.vehicleService.formatBookProviderLabel(
      this.bookProviderService.defaultBookProviderName,
      this.bookProviderService.defaultBookProviderValue
    );
  }

  ngOnInit() {
    this.initializeBookProviderValueLabels();
    this.displayActiveAuctionButtons();
    this.isSharedList = this.bidListStateService.isSharedList;
    this.getTranslations();
    this.setCollapsedBidListState();

    this.bidItem.highestBidderName ? this.highBidderNameToolTip() : null;

    this.setFailedAutoBidBanner();

    this.currentTime = this.dateUtilService.getUnixTimestamp();
    this._startTime = this.dateUtilService.convertToMilliseconds(this.bidItem.auctionStartTime.toLocaleString());
    this.endTime = this.dateUtilService.convertToMilliseconds(this.bidItem.auctionEndTime.toLocaleString());
    this.extendedTime = this.dateUtilService.convertToMilliseconds(this.bidItem.auctionExtendEndTime.toLocaleString());

    this._connectSocketAuctionItem();

    if (this.currentTime < this._startTime && this.vehicleTypeCode !== 'ISV') {
      this.showStartTime = true;
    }

    if (
      this.currentTime > this._startTime &&
      !this.bidItem.auctionExtendBiddingFlag &&
      this.vehicleTypeCode !== 'ISV'
    ) {
      this.showEndTime = true;
    }

    if (this.bidItem.auctionExtendBiddingFlag && this.vehicleTypeCode !== 'ISV') {
      this.showExtendedTime = true;
    }

    if (this.bidItem.offerListExpiryDate) {
      this.showSellerOfferExpiry =
        !this.dateUtilService.isLessThanCurrentDateAndTime(
          this.dateUtilService.formatDate(this.bidItem.offerListExpiryDate)
        ) && !this.isSharedList;
    }

    this.isMobile = window.matchMedia('(max-width: 768px)').matches;
    this.isTablet = window.matchMedia('(min-width:769px) and (max-width: 1200px)').matches;

    this.store
      .select(_state => _state.org.organization)
      .pipe(take(1))
      .subscribe(_organization => {
        if (_organization) {
          this.organization = _organization;
        }
      });

    if (this.bidItem.hasOfferHistory) {
      this.waitingForOffers = false;
    }

    if (this.bidItem.purchaseType === 'WINNING_BID') {
      this.getBidHistory();
    }

    if (!this.isSharedListVehicleSelected) {
      this.sharedListToggleService.uncheckSelectAllCheckbox();
    }

    if (!this.isBidListVehicleSelected) {
      this.bidListToggleService.uncheckSelectAllCheckbox();
    }

    /* istanbul ignore next */
    this.imgUrlLarge = this.get('itemDetail.image')
      .toString()
      .replace('.jpg', '_large.jpg');

    this.getLeadBuyerState();
  }

  get isDeliveryLinkDisplayed() {
    return !['SOLD', 'WON'].includes(this.bidItem.buyerAuctionItemStatus);
  }

  get showShippingQuote(): boolean {
    return this._launchDarklyService.getFeatureFlag('transportationOrderEnabled', false);
  }

  get showDelivery(): boolean {
    return this._launchDarklyService.getFeatureFlag('deliveryEnabled', false);
  }

  get showVOCItems(): boolean {
    return this._launchDarklyService.getFeatureFlag('vocItemsEnabled', false);
  }

  get bidEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('bid-enabled', false);
  }

  get isBidListMoaRecommendationsEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('moa-inApp-bidlistRecommendationEnabled', false);
  }

  get commonMultiCheckboxImplementationEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('commonMultiCheckboxImplementationEnabled', false);
  }

  get isInServiceVehiclesEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('platform-inServiceVehiclesEnabled', false);
  }

  /** Spare key purchase feature flag; LD targeting already scopes it to Avis US. */
  get spareKeyPurchaseEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('spareKey-purchaseEnabled', false);
  }

  /** Pre-purchase only: hidden once WON or SOLD; a purchased fee shows in the fees tooltip instead. */
  get showSpareKeyFee(): boolean {
    return (
      this.spareKeyPurchaseEnabled &&
      !!this.bidItem?.hasSpareKey &&
      this.bidItem?.buyerAuctionItemStatus !== 'WON' &&
      this.bidItem?.buyerAuctionItemStatus !== 'SOLD' &&
      this.platformSpareKeyFee != null
    );
  }

  ngAfterViewChecked() {
    this.changeDetector.detectChanges();
  }

  ngOnDestroy() {
    this.modalLauncherService.clearIfOwnedBy(this);
    super.ngOnDestroy();
  }

  detectIfMobile() {
    this.isMobile = window.matchMedia('(max-width: 768px)').matches;
    this.isTablet = window.matchMedia('(min-width:769px) and (max-width: 1200px)').matches;
  }

  editComment(e) {
    e.preventDefault();
    this.detectIfMobile();
    this.editingComment = true;
  }

  cancelEditComment() {
    this.editingComment = false;
  }

  updateComment(buyerComment: string) {
    this.showCommentsModal();
    const { auctionItemUuid, financeSourceUuid, financeSourceAch, buyerOeUuid, localDelivery } = this.bidItem;
    this.bidListService
      .updateBidListItem({
        financeSourceUuid,
        financeSourceAch,
        auctionItemUuid,
        buyerComment,
        buyerOeUuid,
        localDelivery
      })
      .pipe(take(1))
      .subscribe(
        () => {
          this.bidItem = {
            ...this.bidItem,
            buyerComment
          };
          this.commentsModalInstance.state = 'success';
          this.changeDetector.markForCheck();
          this._analyticsService.track('customEvent', {
            name: this.bidListCommentName,
            attr: {
              formValues: {
                name: this.bidListCommentName,
                status: 'success',
                errors: null,
                type: '',
                step: '1',
                stepname: '',
                items: [
                  {
                    allow: 'yes',
                    error: null,
                    name: 'Comment',
                    track: 'no',
                    value: buyerComment
                  }
                ]
              }
            }
          });
        },
        err => {
          const error = err.error.errors[0];
          this.setBannerError(err);
          this.showBanner = true;
          this.banner.showIcon = true;
          this.banner.showUndo = false;
          this.banner.mode = BannerMode.ERROR;
          this.commentsModalInstance.close();
          this.cleanupModalPortal();
          this._analyticsService.track('customError', this.bannerErrorMsg, this.bannerErrorCode, {
            formValues: {
              name: this.bidListCommentName,
              status: 'error',
              errors: error,
              type: '',
              step: '1',
              stepname: '',
              items: [
                {
                  allow: 'yes',
                  error: null,
                  name: 'Comment',
                  track: 'no',
                  value: buyerComment
                }
              ]
            }
          });
        }
      );
  }

  setBannerError(errorResponse) {
    const error = errorResponse.error.errors[0];
    this.vehicleRemovedSuccessMsg = false;
    this.bannerErrorCode = error.code;
    this.bannerErrorMsg = this.bannerErrorCode;
    this.getTranslations();
    this.banner.text = this.bannerErrorMsg;
  }

  closeListViewPopover() {
    if (this.isListView) {
      this.closePopover();
    }
  }

  offerButtonAnalyticsText(value) {
    return value === 'ACCEPTING_OFFERS' ? 'Make Offer' : 'View Offer';
  }

  bidButtonAnalyticsText(value) {
    return value === 'PENDING' || value === 'OPEN' ? 'Update Bid' : 'Bid';
  }

  openOfferModals() {
    // opens the single accept modal for ISV vehicles that are in pending buyer action.
    if (this.vehicleTypeCode === 'ISV' && this.bidItem.buyerAuctionItemStatus === 'PENDING_BUYER_ACTION') {
      this.openSharedListCommonActionModal('ACCEPT');
      return;
    }

    if (!this.waitingForOffers) {
      this.offerModalsRef = this.modalLauncherService.open(
        OfferModalsComponent,
        { tenantName: this.tenantName, item: this.offerModalItem, bidItem: this.bidItem, modalId: this.modalId, financeSource: this.selectedFinanceSource },
        this
      );
      this.offerModalsRef.instance.modalEvent.subscribe(event => this.onModalEvent(event));
      if (this.showVOCItems) {
        // Setting the flag to true to call offer history to check for higher existing offers.
        this.offerModalsRef.instance.bidItem.hasOfferHistory = true;
      }
      this.offerModalsRef.instance.show();
      this.closeListViewPopover();
    }
  }

  openSharedListCommonActionModal(modalType: string) {
    this.sharedListCommonActionModalRef = this.modalLauncherService.open(
      SharedListCommonActionModalComponent,
      {
        modalId: 'shared-list-common-action-modal',
        tenantName: this.tenantName,
        item: this.offerModalItem,
        bidItem: this.bidItem,
        offerHistory: this.offerHistory,
        index: this.index,
        financeSource: this.selectedFinanceSource,
        platformSpareKeyFee: this.platformSpareKeyFee
      },
      this
    );
    this.sharedListCommonActionModalRef.instance.show(modalType);
    this.closeListViewPopover();
    setTimeout(() => {
      this.changeDetector.markForCheck();
    }, 2000);
  }

  openAutoBidWithdrawModal() {
    this.autoBidWithdrawModalRef = this.modalLauncherService.open(
      AutoBidWithdrawModalComponent,
      { modalId: this.autoBidWithdrawModalId, tenantName: this.tenantName, item: this.autoBidWithdrawModelItem },
      this
    );
    this.autoBidWithdrawModalRef.instance.withdrawSent.subscribe(() => this.withdrawSent());
    this.autoBidWithdrawModalRef.instance.show();
    this.closeListViewPopover();
  }

  openBidModal() {
    this.bidModalRef = this.modalLauncherService.open(
      this.bidModalComponent,
      {
        tenantName: this.tenantName,
        item: this.bidModalItem,
        modalId: this.bidModalId,
        existingAutoBidAmount: this.bidItem.autoBidAmount,
        bidAllowed: this.bidItem.bidAllowed,
        autoBidEnabled: this.isAutoBidEnabled,
        financeSource: this.selectedFinanceSource
      },
      this
    );
    this.bidModalRef.instance.bidPlaced.subscribe(response => this.bidPlaced(response));
    this.bidModalRef.instance.maxAutoBidAmount.subscribe(amount => this.autoBidPlaced(amount));
    this.bidModalRef.instance.show();
    this.closeListViewPopover();
  }

  openBuyNowModals() {
    this.buyNowModalsRef = this.modalLauncherService.open(
      BuyNowModalComponent,
      {
        tenantName: this.tenantName,
        modalItem: this.bidModalItem,
        modalId: this.buyNowModalId,
        buyNowAmount: this.bidItem.buyNowAmount,
        auctionItem: this.offerModalItem,
        financeSource: this.selectedFinanceSource
      },
      this
    );
    this.buyNowModalsRef.instance.bought.subscribe(() => this.itemBought());
    this.buyNowModalsRef.instance.show();
    this.closeListViewPopover();
  }

  openEditDeliveryModal(event: Event, defaultDeliveryOption: boolean) {
    this.editDeliveryModalsRef = this.modalLauncherService.open(
      EditDeliveryModalComponent,
      { tenantName: this.tenantName, auctionItem: this.bidItem, modalId: this.editDeliveryModalId },
      this
    );
    this.editDeliveryModalsRef.instance.changeDelivery.subscribe(e => this.changeDeliveryOption(e));
    this.editDeliveryModalsRef.instance.show(event, defaultDeliveryOption);
  }

  openEditDealershipModal(event: Event) {
    this.editDealershipModalsRef = this.modalLauncherService.open(
      EditDealershipModalComponent,
      {
        selectedDealership: this.selectedDealership,
        dealerships: this.dealershipCollection,
        modalId: this.editDealershipModalId,
        quoteExist: this.quoteExist
      },
      this
    );
    this.editDealershipModalsRef.instance.selectedDealershipChange.subscribe(e => this.changeSelectedDealership(e));
    this.editDealershipModalsRef.instance.show(event);
  }

  openBidHistoryModal() {
    this.bidHistoryModalRef = this.modalLauncherService.open(
      BidHistoryModalComponent,
      { modalId: this.bidHistoryModalId, tenantName: this.tenantName, modalItem: this.bidModalItem, bidHistory: this.bidHistory },
      this
    );
    this.bidHistoryModalRef.instance.show();
  }

  openMoaRecommendations() {
    this.moaRecommendationsRef = this.modalLauncherService.open(
      MissedOfferAlternativeRecommendationsComponent,
      { bidListVin: this.bidItem.itemDetail.vin },
      this
    );
    this.moaRecommendationsRef.location.nativeElement.setAttribute(
      'data-test-id',
      'app-bidlist-inventory-item-e-slide-out'
    );
    this.moaRecommendationsRef.instance.showMoaRecommendations();
  }

  getBidHistory() {
    this.offersService
      .getBidHistory(this.bidItem.auctionItemUuid)
      .pipe(take(1))
      .subscribe(bidHistory => {
        this.bidHistory = bidHistory.reduce((accumulator, value) => {
          const { bidDate } = value;
          const date = bidDate.split('T')[0];
          if (!accumulator[date]) {
            accumulator[date] = [];
          }
          accumulator[date].push(value);
          return accumulator;
        }, {});
      });
  }

  closeToolTip() {
    this.showToolTip = false;
  }

  onModalEvent(event: OfferModalEvent) {
    switch (event.type) {
      case 'Cancel': {
        this.offerModalsRef.instance.close();
        break;
      }
      case 'MakeOffer': {
        this.bidItem.buyerAuctionItemStatus = 'PENDING_SELLER_ACTION';
        this.bidItem.buyerPurchaseStatus = 'Offer Submitted';
        this.bidItem.hasOfferHistory = true;
        this.delayHistoryRequest();
        break;
      }
      case 'WithdrawOffer': {
        this.bidItem.buyerPurchaseStatus = 'Offer Withdrawn';
        this.bidItem.buyerAuctionItemStatus = 'ACCEPTING_OFFERS';
        this.delayHistoryRequest();
        break;
      }

      case 'CounterOffer': {
        this.bidItem.buyerPurchaseStatus = 'Offer Submitted';
        this.bidItem.buyerAuctionItemStatus = 'PENDING_SELLER_ACTION';
        this.delayHistoryRequest();

        break;
      }

      case 'AcceptOffer': {
        this.bidItem.buyerPurchaseStatus = 'Offer Accepted';
        this.bidItem.buyerAuctionItemStatus = 'WON';
        this.bidItem.auctionItemStatus = 'SOLD';
        this.bidItem.buyNowAllowed = false;
        this.delayHistoryRequest();

        break;
      }

      case 'DeclineOffer': {
        this.bidItem.buyerPurchaseStatus = 'Offer Declined';
        this.bidItem.buyerAuctionItemStatus = 'ACCEPTING_OFFERS';
        this.delayHistoryRequest();
        break;
      }
      default: {
        this.waitingForOffers = false;
        break;
      }
    }
  }

  delayHistoryRequest() {
    this.waitingForOffers = true;
    setTimeout(() => {
      this.getOfferHistory();
    }, 5000);
  }

  getOfferHistory() {
    this.offersService
      .getOfferHistory$(this.bidItem.auctionItemUuid)
      .pipe(
        take(1),
        finalize(() => {
          this.waitingForOffers = false;
          this.changeDetector.markForCheck();
        })
      )
      .subscribe(offers => (this.offerHistory = offers));
  }

  itemBought() {
    this.bidItem.buyerAuctionItemStatus = 'WON';
    this.bidItem.buyerPurchaseStatus = 'WON';
    this.bidItem.auctionItemStatus = 'SOLD';
    this.bidItem.buyNowAllowed = false;
    this.bidItem.bidAllowed = false;
    this.bidItem.offerAllowed = false;
    setTimeout(() => {
      this.offerActionButton.nativeElement.focus();
    }, 100);
  }

  bidPlaced(e: BidResponse) {
    this.bidItem = {
      ...this.bidItem,
      openingPrice: false,
      buyNowAllowed: false,
      offerAllowed: false
    };

    this.highBidderNameToolTip();

    this.offerModalItem = OfferModalItem.fromBidItem((this.bidItem as unknown) as BidItem);
    this.delayHistoryRequest();
  }

  closeBidModel(e) {
    this.errorMessage = null;
    this.bidModalRef.instance.close();
  }

  removeFromBidList() {
    this.translocoService
      .selectTranslate('vehicles.bidlistInventoryItem.textSuccesfullyRemoved', { title: this.title })
      .pipe(take(1))
      .subscribe(val => {
        this.bidlistInventoryItemTranslations.bannerTextSuccesfullyRemoved = val;
      });
    this.actionSubmittingModalRef = this.modalLauncherService.open(
      ActionSubmittingModalComponent,
      { tenantName: this.tenantName, actionText: this.actionTextRemovingBid, modalId: this.actionSubmittingModalId },
      this
    );
    this.actionSubmittingModalRef.instance.show();
    this.bidListService
      .removeItemFromBidList(this.bidItem.auctionItemUuid)
      .pipe(
        take(1),
        tap(response => {
          this.hide = true;
          this.removeItem.emit();
          this.showBanner = true;
          this.vehicleRemovedSuccessMsg = true;
          this.banner.text = this.bidlistInventoryItemTranslations.bannerTextSuccesfullyRemoved;
          this.banner.showIcon = false;
          this.banner.showUndo = false;
          this.banner.mode = BannerMode.NONE;
          this.actionSubmittingModalRef.instance.close();
          this.store.dispatch(new RemoveFromBidList(this.bidItem.inventoryItemUuid));
        }),
        catchError(response => this.handleBidListError(response))
      )
      .subscribe();
  }

  handleBidListError(errorResponse: HttpErrorResponse) {
    this.actionSubmittingModalRef.instance.close();
    try {
      const error = get(errorResponse, 'error.errors[0]');
      this.vehicleRemovedSuccessMsg = false;
      this.bannerErrorCode = error.code;
      this.bannerErrorMsg = this.bannerErrorCode;
      this.getTranslations();
      this.banner.text = this.bannerErrorMsg;
      this.showBanner = true;
      this.banner.showIcon = true;
      this.banner.showUndo = false;
      this.banner.mode = BannerMode.ERROR;
    } catch (e) {
      // Do nothing
    }
    return of();
  }

  undoBanner() {
    this.showBanner = false;
    this.hide = false;
    this.readdItem.emit();
  }

  closeBanner() {
    this.showBanner = false;
  }

  showOfferButton() {
    return this.userIsNotSeller && this.handleOfferHistory && this.hasNoPendingAutoBid;
  }

  get userIsNotSeller() {
    return (
      this.bidItem.seller.organizationEntityUuid !==
      this.store.selectSnapshot(state => get(state, 'user.userProfile.oeUuid', ''))
    );
  }

  get handleOfferHistory() {
    return (
      this.bidItem.hasOfferHistory ||
      (this.bidItem.offerAllowed && this.bidItem.auctionItemStatus === 'ACTIVE') ||
      (this.bidItem.offerAllowed && this.bidItem.buyerAuctionItemStatus === 'ACCEPTING_OFFERS')
    );
  }

  get hasNoPendingAutoBid(): boolean {
    return this.bidItem.autoBidStatus !== 'PENDING';
  }

  showBidButton() {
    return (this.bidItem.bidAllowed && this.bidEnabled) || (this.bidItem.autoBidAllowed && this.isAutoBidEnabled);
  }

  showBuyNowButton() {
    return (
      this.bidItem.buyNowAllowed && get(this.bidItem, 'buyNowAmount', 0) > 0 && this.bidItem.autoBidStatus !== 'PENDING'
    );
  }

  getUrl() {
    const url = this.get('itemDetail.image');
  }

  updateAutoBidDetailsFromWebsocket(payload) {
    if (this.bidItem.autoBidAmount && this.bidItem.autoBidAmount < payload.bidAmount) {
      this.bidItem.autoBidAmount = undefined;
      this.bidItem.autoBidStatus = 'closed';
      this.bidModalItem.autoBidStatus = 'closed';
    }
  }

  private _connectSocketAuctionItem(): void {
    const handleUpdateInventoryItem = payload => {
      const attrs = this._auctionItemService.transform(payload, this.bidItem as any);

      this.updateAutoBidDetailsFromWebsocket(payload);

      this.bidItem = {
        ...this.bidItem,
        currentAmount: payload.bidAmount || this.bidItem.currentAmount,
        openingPrice: attrs.isOpeningPrice,
        highestBidderName: attrs.leadBidderName,
        buyerAuctionItemStatus: (attrs.auctionItemStatus as any) || this.bidItem.buyerAuctionItemStatus,
        buyerPurchaseStatus: attrs.purchaseStatus || this.bidItem.buyerPurchaseStatus,
        bidAllowed: isNil(payload.bidAllowed) ? this.bidItem.bidAllowed : payload.bidAllowed,
        autoBidAllowed: isNil(payload.bidAllowed)
          ? this.bidItem.bidAllowed || (this.bidItem.autoBidAllowed && this.isAutoBidEnabled)
          : payload.bidAllowed && this.isAutoBidEnabled,
        offerAllowed: isNil(payload.offerAllowed) ? this.bidItem.offerAllowed : payload.offerAllowed,
        offerAmount: attrs.offerAmount || payload.amount || this.bidItem.offerAmount,
        offerStatus: isNil(payload.offerStatus) ? this.bidItem.offerStatus : payload.offerStatus,
        buyNowAllowed: isNil(payload.buyNowAllowed) ? this.bidItem.buyNowAllowed : payload.buyNowAllowed,
        salePrice: this.getWinningOffer(payload.salePrice),
        buyerOeUuid: payload.buyerOeUuid || this.bidItem.buyerOeUuid,
        buyFee: payload.buyFee || this.bidItem.buyFee
      };
      this.getFeeSize();
      this.displayActiveAuctionButtons();
      this.bidItemUpdated.emit(this.bidItem);
    };

    this._launchDarklyService
      .waitForLaunchDarkly()
      .pipe(
        skipWhile(ready => !ready),
        take(1)
      )
      .subscribe(() => {
        const oeUuid = this.store.selectSnapshot(OrganizationState.oeUuid);
        this._websocketService
          .watch(`${WebsocketUrl.ORGANIZATION_ENTITY}/${oeUuid}`)
          .pipe(
            filter(({ auctionItemUuid }) => auctionItemUuid === this.bidItem.auctionItemUuid),
            takeUntil(this.destroyed$),
            tap(() => this.onItemUpdate.emit()),
            tap(item => handleUpdateInventoryItem(item))
          )
          .subscribe(() => {
            this.changeDetector.markForCheck();
          });

        this._websocketService
          .watch(`${WebsocketUrl.AUCTION_ITEM}/${this.bidItem.auctionItemUuid}`)
          .pipe(
            takeUntil(this.destroyed$),
            tap(() => this.onItemUpdate.emit()),
            tap(item => handleUpdateInventoryItem(item))
          )
          .subscribe(() => {
            this.changeDetector.markForCheck();
          });
      });
  }

  private getWinningOffer(salePrice: number): number {
    return isNil(salePrice) ? this.bidItem.salePrice : salePrice;
  }

  private showCommentsModal() {
    const ref = this.modalLauncherService.open(SaveCommentModalComponent, { tenantName: this.tenantName }, this);
    this.commentsModalInstance = ref.instance;
    this.commentsModalInstance.show();
  }

  private cleanupModalPortal() {
    this.modalLauncherService.clearIfOwnedBy(this);
  }

  get isCanadianTenantEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('canadianTenantEnabled', false);
  }

  get auctionStartTime() {
    return this.bidItem.auctionStartTime;
  }

  get auctionEndTime() {
    return this.bidItem.auctionEndTime;
  }

  get offerListExpiryDate() {
    return this.bidItem.offerListExpiryDate;
  }

  get auctionExtendedTime() {
    return this.bidItem.auctionExtendEndTime;
  }

  localizeDateAndTime(dateTime) {
    return this.dateUtilService.localizeDateAndTime(dateTime, true);
  }

  formatCurrency(currency, withCents) {
    return this.currencyFormatService.formatCurrency(currency, withCents).replaceAll('-', '');
  }

  /** See `totalPurchasePriceBase` for the full rule. SAT-94704. */
  get showTotalPurchasePrice(): boolean {
    return !isNil(this.totalPurchasePriceBase);
  }

  get showTotalPurchasePriceWithCents(): boolean {
    return this.isCanadianTenantEnabled && this.bidItem.buyerAuctionItemStatus === 'WON';
  }

  highBidderNameToolTip() {
    this.highBidderToolTip = {
      metaTitle: this.bidlistInventoryItemTranslations.highBidderToolTipMetaTitle,
      body: this.bidItem.highestBidderName
    };
  }

  get isEditable(): boolean {
    /* Websocket does not correctly update auctionItemStatus.
    Fixing this would require significant re-work in webcore (bid list/shared list/auctionItemService) to correct attribute names and handle
    the auction item status correctly as well as a full retest of all websocket events consumed on the bid list and shared list.
    */
    return ['ACTIVE', 'HOLD', 'RESERVED'].includes(this.bidItem.auctionItemStatus)
      && !['WON', 'SOLD', 'EXPIRED', 'REMOVED', 'NOT_SOLD', 'VEHICLE_REMOVED', 'VEHICLE_EXPIRED', 'RANK_ONLY'].includes(this.bidItem.buyerAuctionItemStatus);
  }

  get isDeliveryEditable() {
    if (this.localDealer) {
      const status = this.bidItem.buyerAuctionItemStatus;
      return status !== 'SOLD' && status !== 'WON';
    } else {
      return false;
    }
  }

  get displayBuyerTip() {
    return this.buyerTipEnabled;
  }

  get autoBidWithdrawModelItem(): AutoBidWithdrawModalItemModel {
    const { auctionItemUuid, financeSourceUuid, financeSourceAch, buyerOeUuid, localDelivery } = this.bidItem;
    return {
      amount: this.bidItem.autoBidAmount,
      auctionItemUuid,
      buyerOeUuid,
      financeSourceUuid,
      financeSourceAch,
      localDelivery,
      autobidUuid: this.bidItem.autoBidUuid,
      vin: this.bidItem.itemDetail.vin,
      auctionStartTime: this.auctionStartTime.toString()
    };
  }

  withdrawSent() {
    this.bidListService
      .getBidListItem(this.bidItem.auctionItemUuid)
      .pipe(take(1))
      .subscribe(response => {
        this.bidItem = response;
      });
  }

  get locationText() {
    let cityStateCombo = this.bidItem.storageLocation.city + ', ' + this.bidItem.storageLocation.state;
    const distance = ` - ${this.bidItem.vehicleDistance} ${this.bidlistInventoryItemTranslations.distanceUnit}`;
    let maxLength;

    if (!this.isMobile && !this.isTablet) {
      maxLength = 35;
    } else if (!this.isMobile && this.isTablet) {
      maxLength = 25;
    } else if (this.isMobile && !this.isTablet) {
      maxLength = 20;
    }
    const maxCityStateLength = maxLength - distance.length - 3; // 3 characters for the ellipses; Must always display the distance.
    if (cityStateCombo.length + distance.length > maxLength) {
      cityStateCombo = cityStateCombo.substring(0, maxCityStateLength) + '...';
    }
    return cityStateCombo + distance;
  }

  get locationToolTipText() {
    const cityStateCombo = this.bidItem.storageLocation.city + ', ' + this.bidItem.storageLocation.state;
    const distance = ` - ${this.bidItem.vehicleDistance} ${this.bidlistInventoryItemTranslations.distanceUnit}`;
    return {
      metaTitle: this.bidlistInventoryItemTranslations.locationToolTip,
      body: cityStateCombo + distance
    };
  }

  autoBidPlaced(maxAutoBidAmount: number) {
    // Makes call for bidItem to get current bid item state after placing autobid since autobid response does not contain information
    setTimeout(() => {
      this.bidListService
        .getBidListItem(this.bidItem.auctionItemUuid)
        .pipe(take(1))
        .subscribe(bidItem => {
          this.bidItem = bidItem;
          this.bidItem.autoBidAmount = maxAutoBidAmount;
        });
    }, 5000);
  }

  setFailedAutoBidBanner() {
    if (this.bidItem.autoBidError) {
      this.showBanner = true;
      this.banner.text = this.bidItem.autoBidError;
      this.banner.showIcon = true;
      this.banner.showUndo = false;
      this.banner.mode = BannerMode.AUTOBID_FAILED;
    }
  }

  setCollapsedBidListState() {
    // The store is the only source of collapsed state, so a bulk change reaches rows that were
    // never rendered. Subscribing here emits synchronously, which seeds a row mounting mid-scroll
    // before its first render; correcting its height a frame later would move the mean that the
    // virtual scroll strategy uses for every row it has not measured.
    this.store.select(VDPConfigurationState.currentUserState)
      .pipe(
        map(userConfig => this.isCollapsedInConfig(userConfig)),
        distinctUntilChanged(),
        takeUntil(this.destroyed$)
      )
      .subscribe(isCollapsed => {
        this.collapsedState = isCollapsed;
        this.changeDetector.markForCheck();
      });
  }

  /**
   * `bidListCollapsedState` lists only the VINs that disagree with `bidListDefaultCollapsed`, so an
   * absent flag reads as collapsed and state stored before the flag existed still resolves.
   */
  private isCollapsedInConfig(userConfig: UserConfiguration): boolean {
    const defaultCollapsed = userConfig?.bidListDefaultCollapsed !== false;
    const differsFromDefault = userConfig?.bidListCollapsedState?.includes(this.bidItem.itemDetail.vin) ?? false;
    return defaultCollapsed !== differsFromDefault;
  }

  toggleCollapsedState() {
    this.store.dispatch(new SetCurrentUser());
    this.store.dispatch(new UpdateBidListCollapsedState(this.bidItem.itemDetail.vin));
  }

  get isCollapsed(): boolean {
    return this.collapsedState && !this.isMobile;
  }

  get feeTooltipMoreInformationLabel() {
    return this.taxesPresent()
      ? this.bidlistInventoryItemTranslations.feesAndTaxesTooltipAriaLabel
      : this.bidlistInventoryItemTranslations.feesTooltipAriaLabel;
  }

  get feeDetailsTooltip() {
    this.bidlistInventoryItemTranslations.tooltipContent = this.tooltipService.getFeeValues(this.bidItem.buyFee.fees);
    return {
      metaTitle: this.feeTooltipMoreInformationLabel,
      body: this.bidlistInventoryItemTranslations.tooltipContent
    };
  }

  // ---------------------------------------------------------------------------
  // All-in pricing (drip pricing, Canada's Competition Act)
  //
  // An advertised price the buyer cannot actually pay is deceptive marketing, so behind the
  // `buy-allInPricingEnabled` flag the prices on this card include the *required* fees
  // (service + documentation). Transportation is optional and tax is not a fee, so neither is
  // part of the all-in price.
  //
  // M3 concluded from that the "Fees and Taxes" row could be left alone. M4.16 corrects it: the
  // required fees ARE in that row's total as well as inside the prices above, so leaving it showed
  // the same money twice. The row is now gated on `showFeeRows` on all four renderings of this card
  // (the card body, the mobile `#listview`, and the desktop table through
  // `ListRowInventoryItemComponent.showFees`), and the transportation amount the all-in price
  // excludes gets a row of its own instead.
  // ---------------------------------------------------------------------------

  /**
   * All-in pricing is a buyer-side compliance change. It applies only to unsold listings the buyer
   * can still act on, and never to the seller journeys: the shared list, in-service vehicles and
   * custom offers all live under `isSharedList`, so that single gate covers all three.
   */
  /**
   * Bound by all five breakdown icons on this card and its list-view subclass instead of each
   * repeating the trigger list. See the constant for why every one of the four triggers is
   * load-bearing; the short version is that TooltipComponent's default is narrower and losing a
   * trigger produces an icon that still looks like it works.
   */
  readonly dripTooltipTriggers = DRIP_TOOLTIP_TRIGGERS;

  get isDripPricingApplicable(): boolean {
    return this.dripPricingService.isDripPricingEnabled && !this.isSharedList && !this.isPurchasedVehicle;
  }

  /**
   * Which Bid modal this row opens: the refactor twin whenever the VDP this same row links to would
   * open it, and the legacy one otherwise.
   *
   * WHY THE BID LIST STOPPED OWNING A SEPARATE ANSWER. Until now this call site named
   * BidModalComponent outright, so a buyer in the refactor bucket got the refactor modal from the
   * VDP and the legacy one from the bid list -- two different modals for the same action on the same
   * listing. The refactor modal is not a restyle: it carries the vehicle title and VIN block
   * (`.bid_vehicle`), the "Select Bid Type" heading and the aligned stepper icons. Reproducing those
   * in the legacy modal would be a second implementation of a component that already exists, and the
   * two would then have to be kept in step forever.
   *
   * BOTH flags, deliberately. vdp-AIRefactorEnabled alone is what makes the two surfaces agree --
   * it is the same flag CommonListComponent.getVdpRefactorFlag() already reads to decide which VDP a
   * row navigates to, so the modal now follows the row. buy-allInPricingEnabled is ANDed on top
   * because the drip kill switch has to reproduce pre-drip output exactly: with drip off this row
   * must open the same modal it opens in production today, and swapping the component would change
   * what a buyer sees for a reason that has nothing to do with drip. With drip on, the VDP's choice
   * is governed by vdp-AIRefactorEnabled alone, so ANDing the two still matches it in every bucket.
   *
   * Safe to swap only because the two components present the SAME contract -- identical input and
   * output names, and show()/close() with the same signatures and behaviour (the refactor show() also
   * calls markForCheck() after focusing the header) -- which is why the inputs below are untouched.
   * The one asymmetry is auctionItemFee, which the refactor modal declares as a signal input and
   * this path deliberately leaves unset; its dripFeeSource falls back to the bidItem it fetches in
   * show(), exactly as that input's own docblock describes.
   */
  private get bidModalComponent(): Type<BidModalComponent | BidModalRefactorComponent> {
    return this.dripPricingService.isDripPricingEnabled && this.vdpRefactorEnabled
      ? BidModalRefactorComponent
      : BidModalComponent;
  }

  /**
   * Read here rather than taken from CommonListComponent: this row is created by a virtual scroll
   * viewport and has no guaranteed reference to the list, and the flag read is a cheap map lookup.
   * The KEY must stay identical to the one the VDP route guard uses, or the two surfaces diverge
   * again in exactly the way bidModalComponent exists to prevent.
   */
  private get vdpRefactorEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('vdp-AIRefactorEnabled', false);
  }

  /**
   * Once the vehicle is bought the figures are historical: the buyer agreed to a Total Purchase
   * Price that included every fee and tax, and re-presenting it as an all-in subset would
   * contradict their own paperwork. Purchased vehicles keep today's behaviour end to end.
   */
  private get isPurchasedVehicle(): boolean {
    return this.bidItem?.buyerAuctionItemStatus === 'SOLD' || this.bidItem?.buyerAuctionItemStatus === 'WON';
  }

  private get dripFeeSource(): DripFeeSource {
    return this.bidItem?.buyFee;
  }

  /**
   * The only gate on the FEES / FEES AND TAXES rows, across every rendering of this card.
   *
   * Hidden only while all-in pricing is actually applied, so the seller journeys under `isSharedList`
   * and any purchased vehicle keep the row they have always had -- on a sold vehicle the all-in
   * figures are gone and this row is the buyer's only breakdown.
   *
   * This governs a cell's contents, which every row is free to decide for itself, not whether a
   * column exists. The desktop table therefore keeps its `<td>` and falls to its existing `N/A`
   * branch rather than dropping the cell and shifting every column after it.
   */
  get showFeeRows(): boolean {
    return !this.isDripPricingApplicable;
  }

  /** The quoted transportation amount, or undefined when the payload carries none. */
  private get transportationFee(): number | undefined {
    return this.dripPricingService.transportationFeeOf(this.dripFeeSource);
  }

  /**
   * The same string the eleven modal breakdowns label their transportation row with, read from the
   * same place. Not a new i18n key: a new one would have to be worded, reviewed and translated before
   * it rendered anything, and until then Transloco would print the key name on a field label.
   * `shared.fees.TRANSPORTATION_FEE` is filled in every bundle, and reusing it is also what stops this
   * row being worded differently to the modals that quote the same fee.
   */
  get transportationFeeLabel(): string {
    return this.tooltipService.feeTranslations.TRANSPORTATION_FEE;
  }

  /**
   * Whether a real transportation amount is on screen, as opposed to the N/A that stands in for it.
   *
   * Named rather than inlined because two decisions now turn on it -- the row's own value and whether
   * the fee-schedule link renders beside it -- and they must not be able to disagree.
   *
   * `localDelivery` is read off `bidItem` directly, as everywhere else on this row: unlike the VDP there
   * is no `isDeliveryIncluded` here, because a bid-list row IS on the bid list by definition and so has
   * no off-list branch to reconcile. `!!` treats false (delivery declined) and null/undefined (no
   * election recorded) alike, and both mean the same thing to this row. The '-' the template's
   * delivery block compares against is the default `get()` returns for a missing path, not a
   * `localDelivery` value -- and it is truthy, so it is not one of the states `!!` filters out.
   *
   * `Number.isFinite`, not truthiness: a quoted $0 transportation fee is a real answer and must render
   * as $0.00, with its link. `transportationFeeOf` returns undefined -- never 0 -- when the payload
   * carries no TRANSPORTATION_FEE at all, which is exactly what separates the two cases.
   */
  private get hasTransportationFeeAmount(): boolean {
    return !!this.bidItem?.localDelivery && Number.isFinite(this.transportationFee);
  }

  /**
   * Transportation is NOT part of the all-in price -- `allInPriceOf` excludes it, because the buyer
   * can avoid it by collecting the vehicle -- so suppressing the fee row above left the amount with
   * nowhere to appear. On the card it gets its own row (#ALLINFEEDETAILS, which renders wherever
   * `showFeeRows` is false), beside the fee-schedule link that explains the tiers.
   *
   * SAT-94660: that row renders for the whole of all-in pricing, rather than only when there is an
   * amount or an elected delivery to justify it. A field that disappears cannot be told apart from a
   * field the buyer scrolled past, and transportation is the one figure the all-in price deliberately
   * leaves OUT -- so the buyer is told in words that it does not apply instead of being asked to infer
   * it from an absence. Which of the two things the row says is this getter's decision.
   *
   * The list views carry no transportation row: desktop and mobile both keep the Fees label and show
   * N/A under all-in pricing (QA rows 15 and 31).
   *
   * An amount renders only when the buyer has elected delivery AND the listing quotes a fee. Both
   * halves are load-bearing, for different reasons:
   *
   * - Delivery declined means no transportation is being bought, so a quoted tier figure is not money
   *   this buyer owes. Printing it would overstate what they are about to pay.
   * - Delivery elected with nothing quoted back is a fee that WILL apply and is not yet known.
   *
   * SAT-94660 puts 'N/A' on both. The second case used to show `textTotalPlaceholder` ('$--'), which
   * reads as "an amount is coming" -- true there, false for the first case, and the row cannot show
   * two different empty states without a second decision the comp does not ask for.
   *
   * `notAvailable` is `common.notAvailable`, which this component already reads for its other empty
   * fields. NOT a literal 'N/A': the key is 'S/O' in French. The hardcoded value="N/A" bindings on the
   * FEES rows in this same template are a pre-existing French defect, not a precedent.
   */
  get transportationFeeDisplay(): string {
    return this.hasTransportationFeeAmount ? this.formatCurrency(this.transportationFee, true) : this.notAvailable;
  }

  get dripCurrentAmount(): number | undefined {
    return this.dripPricingService.allInPriceOf(this.bidItem?.currentAmount, this.dripFeeSource);
  }

  get dripBuyNowAmount(): number | undefined {
    return this.dripPricingService.allInPriceOf(this.bidItem?.buyNowAmount, this.dripFeeSource);
  }

  get dripAutoBidAmount(): number | undefined {
    return this.dripPricingService.allInPriceOf(this.bidItem?.autoBidAmount, this.dripFeeSource);
  }

  /**
   * The displayed figures. `!== undefined` rather than truthiness on purpose: a $0 all-in price is
   * a real price, and this repo has no `strictNullChecks` so a falsy check would silently drop it.
   */
  get displayCurrentAmount(): number | undefined {
    return this.isDripPricingApplicable && this.dripCurrentAmount !== undefined
      ? this.dripCurrentAmount
      : this.bidItem?.currentAmount;
  }

  get displayBuyNowAmount(): number | undefined {
    return this.isDripPricingApplicable && this.dripBuyNowAmount !== undefined
      ? this.dripBuyNowAmount
      : this.bidItem?.buyNowAmount;
  }

  get displayAutoBidAmount(): number | undefined {
    return this.isDripPricingApplicable && this.dripAutoBidAmount !== undefined
      ? this.dripAutoBidAmount
      : this.bidItem?.autoBidAmount;
  }

  /** Extracted from the template so the buy now ⓘ can gate on exactly what renders the figure. */
  get isBuyNowPriceAvailable(): boolean {
    return !!(this.get('buyNowAmount', false) && this.bidItem?.buyNowAllowed);
  }

  /**
   * CORRECTION. This getter used to carry a third term, `!!this.bidItem?.currentAmount`, copied from
   * the VDPs along with a comment claiming the card "does not print" a $0 price. The card does print
   * it: unlike the VDPs, which render 'N/A' when the amount is falsy, every rendering of this card
   * prints `formatCurrency(displayCurrentAmount)` unconditionally.
   *
   * So on a listing with `currentAmount: 0` the truthiness term produced the worst available outcome.
   * The figure still became all-in -- $500 of required fees with no vehicle price under it -- and the
   * ⓘ that would have disclosed that was the one thing suppressed. A fee-only total presented as a
   * current bid, with the breakdown deliberately withheld, is the exact failure this epic exists to
   * prevent, and it was hidden behind a comment asserting the opposite.
   *
   * The remaining `!== undefined` is the whole gate the card needs, and it is sufficient: a null or
   * absent amount makes `allInPriceOf` return undefined, so the icon still cannot outlive a figure
   * that was never computed. The icons on the VDPs keep their extra term -- there, the figure really
   * is replaced by 'N/A', so there really is nothing for an ⓘ to explain. The two surfaces disagree
   * because their templates disagree; do not "restore consistency" without changing a template.
   */
  get showDripCurrentAmountTooltip(): boolean {
    return this.isDripPricingApplicable && this.dripCurrentAmount !== undefined;
  }

  get showDripBuyNowTooltip(): boolean {
    return this.isDripPricingApplicable && this.dripBuyNowAmount !== undefined && this.isBuyNowPriceAvailable;
  }

  get dripCurrentAmountTooltip(): { metaTitle: string; title: string; body: string } | null {
    return this.dripTooltipFor(this.bidItem?.currentAmount, DripTotalLabelContext.OPENING_OR_CURRENT_PRICE);
  }

  get dripBuyNowTooltip(): { metaTitle: string; title: string; body: string } | null {
    return this.dripTooltipFor(this.bidItem?.buyNowAmount, DripTotalLabelContext.BUY_NOW_PRICE);
  }

  /**
   * The breakdown body is built by the shared service so the card, both VDPs and the modals cannot
   * drift apart on wording, rounding or which fees count as required.
   */
  private dripTooltipFor(
    amount: number | null | undefined,
    context: DripTotalLabelContext
  ): { metaTitle: string; title: string; body: string } | null {
    const body = this.tooltipService.getDripFeeValues(amount, this.dripFeeSource, context);
    if (body === undefined) {
      return null;
    }
    return {
      metaTitle: this.tooltipService.dripTranslations.ariaLabelPriceBreakdown,
      title: this.tooltipService.dripTranslations.titlePriceBreakdown,
      body
    };
  }

  setAuctionItemFee(buyeroeUuid) {
    this.auctionFeeService
      .getAuctionItemFees(this.bidItem.auctionItemUuid, buyeroeUuid)
      .pipe(take(1))
      .subscribe(value => {
        this.bidItem.buyFee = value.buyFee;
      });
  }

  getFeeSize() {
    try {
      const feesKeyMap = this.feeTooltipFormatterService.getFeeMap(
        this.feeToolTipService.translatedFees(this.bidItem.buyFee.fees)
      );
      this.feeListSize = Object.keys(feesKeyMap).length;
      if (this.bidItem.buyFee.fees && this.feeListSize === 1) {
        for (const key in feesKeyMap) {
          const feeValue = feesKeyMap[key];
          this.bidlistInventoryItemTranslations.singleFeeLabel = key;
          this.singleFeeAmount = this.currencyFormatService.formatCurrency(feeValue, true);
        }
      }
    } catch (err) {
      console.log(err);
    }
    return this.bidItem.buyFee.fees && this.feeListSize;
  }

  getTotalFee() {
    const feeTotal = this.bidItem.buyFee && this.bidItem.buyFee.total;
    return this.currencyFormatService.formatCurrency(feeTotal, true);
  }

  showTransportationFeeModal(event: Event) {
    event.preventDefault();
    this.getTransportationFeeTiers(this.bidItem.seller.organizationEntityUuid, event);
  }

  analyticsInfo(pageDetails: string) {
    this._analyticsService.trackEvent('app-tooltip', pageDetails);
  }

  /**
   * SAT-94660 added the last term. Under all-in pricing the link is suppressed in exactly the two
   * states `transportationFeeDisplay` resolves to N/A: a tier schedule to open invites the buyer to
   * price a fee the row directly beside it is telling them they will not pay, which is the same
   * misdisclosure in the other direction to the one the epic exists to fix.
   *
   * Gated on `isDripPricingApplicable` rather than applied outright, so a flag-off buyer -- and a
   * shared list, and a purchased vehicle, neither of which is an all-in surface -- keeps the link on
   * the terms it has always had.
   *
   * This getter also feeds the #SERVICEFEESINGLE row, which is the flag-OFF branch, so the drip term
   * is inert there by construction.
   */
  get showTransportationFeeLink(): boolean {
    return (
      this.bidItem.transportationFeeTierAvailable &&
      this.bidItem.auctionItemStatus !== 'SOLD' &&
      this.localDealer &&
      (!this.isDripPricingApplicable || this.hasTransportationFeeAmount)
    );
  }

  getTransportationFeeTiers(sellerOeUuid: string, event: Event): void {
    const generation = this.modalLauncherService.generation;
    this.auctionFeeService
      .getTransportationFeeTiers(sellerOeUuid)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        data => {
          // Nothing is on screen while this request is in flight, so any other trigger can claim the
          // shared modal slot in the meantime. Opening now would destroy what the user moved on to.
          if (this.modalLauncherService.generation !== generation) {
            return;
          }
          if (data && data.length > 0) {
            this.transportationFeeModalRef = this.modalLauncherService.open(
              TransportationFeeModalComponent,
              { modalId: this.transportationFeeModalId, transportationFeeTiers: data },
              this
            );
            this.transportationFeeModalRef.instance.show(event);
          }
        },
        error => {
          console.log(`Error retrieving fee tier info for seller ${sellerOeUuid} : ${error}`);
        }
      );
  }

  hasFeeDetails() {
    return this.tooltipService.hasFeeDetails(this.bidItem.buyFee);
  }

  get showViewFeeSchedule(): boolean {
    if (this.bidItem.auctionFeeSchedule) {
      return this.bidItem.auctionFeeSchedule.type === 'PRICE_RANGE';
    }
    return false;
  }

  get auctionFeeScheduleEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('auctionFeeScheduleEnabled', false);
  }

  openFeeScheduleModal(event: Event) {
    event.preventDefault();
    this.getServiceFeeSchedule();
  }

  getServiceFeeSchedule() {
    const generation = this.modalLauncherService.generation;
    this.auctionFeeService
      .getAuctionFeeSchedule(this.bidItem.auctionFeeSchedule.id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        auctionFeeSchedule => {
          // Nothing is on screen while this request is in flight, so any other trigger can claim the
          // shared modal slot in the meantime. Opening now would destroy what the user moved on to.
          if (this.modalLauncherService.generation !== generation) {
            return;
          }
          if (auctionFeeSchedule && auctionFeeSchedule.auctionFeeScheduleRanges.length > 0) {
            this.serviceFeeScheduleModalRef = this.modalLauncherService.open(
              ServiceFeeScheduleModalComponent,
              { modalId: this.feeScheduleModalId, auctionFeeSchedule },
              this
            );
            this.serviceFeeScheduleModalRef.instance.show();
          }
        },
        error => {
          console.log(
            `Error retrieving schedule fee  info for auctionFeeUuid ${this.bidItem.auctionFeeSchedule.id} : ${error}`
          );
        }
      );
  }

  formatQuoteAmount() {
    if (this.bidItem.transportationQuote) {
      this.formattedQuote = this.formatCurrency(this.bidItem.transportationQuote?.quoteAmount, true);
      this.formattedExpiryDate = this.dateUtilService.localizeDate(this.bidItem.transportationQuote?.expiryDate);
      this.bidItem.transportationQuote.quoteAmount = this.formattedQuote;
      this.bidItem.transportationQuote.expiryDate = this.formattedExpiryDate;
    }
  }

  getTranslations() {
    const keyParams = {
      error: {},
      common: {},
      vehicles: {},
      'offerList.general': {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (translation: any[]) => {
          this.financeInlineError = translation[0][this.errorCode];
          this.errorMsg = translation[0][this.errorCode];
          this.bannerErrorMsg = translation[0][this.bannerErrorCode];
          this.localTimeZoneNameExtended = translation[1].localTimeZoneNameExtended;
          this.labelSellerOfferExpires = translation[2].bidlistInventoryItem.labelSellerOfferExpires;
          this.actionTextRemovingBid = translation[2].bidlistInventoryItem.actionTextRemovingBid;
          this.notAvailable = translation[1].notAvailable;
          this.viewSimilarBtn = translation[2].moaRecommendation.viewSimilarBtn;
          this.translations.textStockUnit = translation[2].bidlistInventoryItem.textStockUnit;
          this.translations.textInspectionSeries = translation[3].inspectionSeries;
          this.translations.partOf = translation[3].partOf;
          this.translations.sharedList = translation[3].sharedList;
          this.translations.customOffer = translation[3].customOffer;
          this.translations.currentListType = this.isInServiceVehiclesEnabled && this.vehicleTypeCode !== 'ISV' ? this.translations.customOffer : this.translations.sharedList;
          this.formatQuoteAmount();
        },
        error => {
          console.log(error);
        }
      );
  }

  setOfferLabelValue() {
    if (this.isSharedList && this.vehicleTypeCode === 'ISV') {
      return 'vehicles.bidlistInventoryItem.labelListOffer';
    }
    if (this.isSharedList) {
      return 'vehicles.bidlistInventoryItem.labelSellerOffer';
    } else {
      return 'vehicles.bidlistInventoryItem.labelOfferedAmount';
    }
  }

  setOfferExpiresValue() {
    if (this.vehicleTypeCode === 'ISV') {
      return 'vehicles.bidlistInventoryItem.labelExpirationTime';
    } else {
      return 'vehicles.bidlistInventoryItem.labelSellerOfferExpires';
    }
  }

  setTotalLabelValue() {
    if (this.vehicleTypeCode === 'ISV') {
      return 'vehicles.bidlistInventoryItem.labelTotalOffer';
    } else {
      return 'vehicles.bidlistInventoryItem.labelTotalPurchasePrice';
    }
  }

  get showEllipsis() {
    return this.showBidButton() || this.showOfferButton() || this.showBuyNowButton() || this.isActiveAuctionButtons()
      ? true
      : false;
  }

  displayActiveAuctionButtons() {
    this.activeAuctionButtons = this.isActiveAuctionButtons();
  }

  isOfferDeclinedOrWithdrawn(): boolean {
    return (
      this.bidItem.offerStatus === 'BUYER_WITHDRAWN' ||
      this.bidItem.offerStatus === 'BUYER_DECLINED' ||
      this.bidItem.offerStatus === 'SELLER_DECLINED' ||
      this.bidItem.offerStatus === 'SELLER_WITHDRAWN'
    );
  }

  isActiveAuctionButtons(): boolean {
    if (
      this.bidItem.auctionItemStatus === 'RESERVED' &&
      this.bidItem.offerStatus === SellerOfferStatus.SELLER_OFFERED
    ) {
      return true;
    }
    return !(
      this.bidItem.offerStatus === SellerOfferStatus.BUYER_COUNTERED ||
      this.bidItem.offerStatus === SellerOfferStatus.BUYER_OFFERED ||
      this.isOfferDeclinedOrWithdrawn() ||
      this.bidItem.auctionItemStatus !== 'ACTIVE' ||
      !this.bidItem.offerAllowed
    );
  }

  isPendingBuyerAction(): boolean {
    if (!this.bidItem.offerAllowed && this.vehicleTypeCode !== 'ISV') {
      return false;
    }
    return this.bidItem.buyerAuctionItemStatus === 'PENDING_BUYER_ACTION';
  }

  isPendingSellerAction(): boolean {
    if (!this.bidItem.offerAllowed) {
      return false;
    }
    return this.bidItem.buyerAuctionItemStatus === 'PENDING_SELLER_ACTION';
  }

  closePopover() {
    this.popover.hide();
  }

  taxesPresent(): boolean {
    return this.tooltipService.isTaxesPresent(this.bidItem.buyFee);
  }

  toggleSharedListSelected() {
    this.sharedListToggleService.hasCheckboxActionOverridingScroll = true;
    if (this.isSharedListVehicleSelected) {
      this.store.dispatch(new RemoveSharedListVehicleFromSelections(this.bidItem.auctionItemUuid));
    } else {
      this.store.dispatch(new AddSharedListVehicleToSelections(this.bidItem.auctionItemUuid));
    }
    const selectedVehicles = this.sharedListToggleService.snapShot().selectedVehicles;
    this.paginatedSharedList$.pipe(take(1)).subscribe(result => {
      this.sharedListResults = result.items;
      this.sharedListToggleService.vehicleToggle(this.bidItem.auctionItemUuid);

      if (this.allSelectableItemsAreChecked(this.sharedListResults, selectedVehicles)) {
        this.sharedListToggleService.checkSelectAllCheckbox();
      } else {
        this.sharedListToggleService.uncheckSelectAllCheckbox();
      }
    });
  }

  allSelectableItemsAreChecked(bidList: BidItem[], selectedVehicles: string[]): boolean {
    if (bidList.length === 0 || selectedVehicles.length === 0) {
      return false;
    }
    const reducedBidList = bidList.reduce((items, item) => {
      if (item.buyerAuctionItemStatus === 'PENDING_BUYER_ACTION') {
        items.push(item);
      }
      return items;
    }, []);
    const currentResponseAuctionItemUuids = reducedBidList.map(item => item.auctionItemUuid);
    return currentResponseAuctionItemUuids.every(result => selectedVehicles.map(v => v).includes(result));
  }

  isSharedListCheckboxEnabled(): boolean {
    if (this.isSharedListVehicleSelected && !this.isPendingBuyerAction()) {
      this.toggleVehicleCheckboxSelected();
    }

    return (
      this.isSharedList &&
      this.hasDealerAndListNameSpecified &&
      (this.isPendingBuyerAction() || this.isPendingSellerAction()) &&
      this.isOfferListBuyerSelectAllEnabled &&
      !(this.isListView && !this.hasItemPendingAction)
    );
  }

  isSharedListCheckboxSelected(): boolean {
    return this.isSharedListVehicleSelected && this.isPendingBuyerAction();
  }

  isBidListCheckboxSelected(): boolean {
    return this.isBidListVehicleSelected && this.isRemovableBidListItem();
  }

  get isVehicleCheckboxSelected(): boolean {
    if (this.commonMultiCheckboxImplementationEnabled) {
      return (
        this.isVehicleSelected && (this.isSharedList ? this.isPendingBuyerAction() : this.isRemovableBidListItem())
      );
    } else {
      return this.isSharedList ? this.isSharedListCheckboxSelected() : this.isBidListCheckboxSelected();
    }
  }

  get hasDealerAndListNameSpecified(): boolean {
    return this.sharedListStateService.hasDealerAndListNameSpecified;
  }

  get hasItemPendingAction(): boolean {
    return this.sharedListStateService.hasItemPendingAction;
  }

  get hasRemovableBidListItem(): boolean {
    return this.bidListStateService.hasRemovableBidListItem;
  }

  get showCheckboxColumnForListView(): boolean {
    return (this.isSharedList && this.hasItemPendingAction) || (!this.isSharedList && this.hasRemovableBidListItem);
  }

  get isOfferListBuyerSelectAllEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('offerlist-buyer-selectAllEnabled', true);
  }

  get isInspectionSeriesEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('platform-inspectionSeriesEnabled', false);
  }

  get vehicleTypeCode() {
    return get(this.bidItem, 'vehicleTypeCode', '');
  }

  getLeadBuyerState() {
    this.store
      .select(state => state.leadBuyer)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(leadBuyerState => {
        this.leadBuyerState = leadBuyerState;
      });
  }

  showFeesAndTaxes(): boolean {
    return this.isLeadBuyer
      ? !!this.leadBuyerState.availableDealerships.find(dealership => dealership.oeUuid === this.bidItem.buyerOeUuid)
      : this.bidItem.buyerOeUuid === this.organization.oeUuid;
  }

  fireEventOnAnchorClick(e) {
    const linkDescription = get(e, 'linkDescription', undefined);
    const linkTarget = get(e, 'linkTarget', undefined);
    this._analyticsService.fireEventOnAnchorClick(linkDescription, linkTarget);
  }

  get multiVehicleRemovalEnabled(): boolean {
    return this._launchDarklyService.getFeatureFlag('bidlist-buyer-selectRemoveEnabled', false);
  }

  toggleBidListSelected() {
    this.bidListToggleService.hasCheckboxActionOverridingScroll = true;
    if (this.isBidListVehicleSelected) {
      this.store.dispatch(new RemoveBidListVehicleFromSelections(this.bidItem.auctionItemUuid));
    } else {
      this.store.dispatch(new AddBidListVehicleToSelections(this.bidItem.auctionItemUuid));
    }
    const selectedVehicles = this.bidListToggleService.snapShot().selectedVehicles;
    this.paginatedBidList$.pipe(take(1)).subscribe(result => {
      this.bidListResults = result.items;
      this.bidListToggleService.vehicleToggle(this.bidItem.auctionItemUuid);

      if (this.allSelectableBidListItemsAreChecked(this.bidListResults, selectedVehicles)) {
        this.bidListToggleService.checkSelectAllCheckbox();
      } else {
        this.bidListToggleService.uncheckSelectAllCheckbox();
      }
    });
  }

  toggleVehicleCheckboxSelected() {
    if (this.commonMultiCheckboxImplementationEnabled) {
      this.toggleVehicleSelected();
    } else {
      this.isSharedList ? this.toggleSharedListSelected() : this.toggleBidListSelected();
    }
  }

  toggleVehicleSelected() {
    if (this.isVehicleCheckboxSelected) {
      this.store.dispatch(new RemoveVehicleUuidFromSelections(this.bidItem.auctionItemUuid));
    } else {
      this.store.dispatch(new AddVehicleUuidToSelections(this.bidItem.auctionItemUuid));
      this.onReviewSelectAllNeeded.emit();
    }
  }

  allSelectableBidListItemsAreChecked(bidList: BidItem[], selectedVehicles: string[]): boolean {
    if (bidList.length === 0 || selectedVehicles.length === 0) {
      return false;
    }
    const reducedBidList = bidList.reduce((items, item) => {
      if (this.isRemovableBidListItem()) {
        items.push(item);
      }
      return items;
    }, []);
    const currentResponseAuctionItemUuids = reducedBidList.map(item => item.auctionItemUuid);
    return currentResponseAuctionItemUuids.every(result => selectedVehicles.map(v => v).includes(result));
  }

  isRemovableBidListItem(): boolean {
    let vehicleList = this.store.selectSnapshot(VehicleToggleState.selectedVehicles);

    if (vehicleList.length >= this.bidlistMultiRemoveLimit && !vehicleList.includes(this.bidItem.auctionItemUuid)) {
      return false;
    }

    vehicleList = this.bidListToggleService.snapShot().selectedVehicles;

    if (
      vehicleList.length >= BidListToggleService.BIDLIST_MULTI_REMOVE_LIMIT &&
      !vehicleList.includes(this.bidItem.auctionItemUuid)
    ) {
      // REMOVE BELOW WHEN SWAPPING OVER TO COMMON CHECKBOX IMPLEMENTATION ONLY THIS SCENARIO
      return false;
    }

    const buyerAuctionItemStatus = this.bidItem.buyerAuctionItemStatus;
    return (
      this.isBidListCheckboxEnabled() &&
      !(
        buyerAuctionItemStatus === 'PENDING_BUYER_ACTION' ||
        buyerAuctionItemStatus === 'PENDING_SELLER_ACTION' ||
        buyerAuctionItemStatus === 'LEADING' ||
        buyerAuctionItemStatus === 'PENDING_BID'
      )
    );
  }

  isBidListCheckboxEnabled(): boolean {
    const buyerAuctionItemStatus = this.bidItem.buyerAuctionItemStatus;
    const auctionItemStatus = this.bidItem.auctionItemStatus;

    return (
      this.multiVehicleRemovalEnabled &&
      !this.isSharedList &&
      this.bidListMultiSelectEnabled &&
      !(
        buyerAuctionItemStatus === 'WON' ||
        auctionItemStatus === 'SOLD' ||
        auctionItemStatus === 'HOLD' ||
        auctionItemStatus === 'REMOVED'
      )
    );
  }
}
